export const READ_ALL_MESSAGES_ERROR_MESSAGE = 'Erro ao marcar todas as mensagens como lidas.'

export const READ_ALL_MESSAGES_SUCCESS_MESSAGE = 'Todas as notificações foram marcadas como lidas.'
